import { ReactNode } from 'react';
import { COLORS } from '@connect-x-app/shared-ui';
import { partTestId } from '@connect-x-app/shared-utils';
import classnames from 'classnames';

import { Icon } from '../icon';
import { ModalOpener } from './ModalOpener';

import './modal.scss';

const handleCancel = (onCancel?: () => void) => {
  if (onCancel) {
    onCancel();
  } else {
    ModalOpener.instance.close();
  }
};

type ModalProps = {
  children: ReactNode;
  className?: string;
  onCancel?: () => void;
  preventBackdropDismiss?: boolean;
  testId?: string;
};

type HeaderProps = {
  children: ReactNode;
  onCancel?: () => void;
  testId?: string;
};

const Header = ({ children, onCancel, testId }: HeaderProps) => {
  return (
    <header className="modal-header">
      <h1>{children}</h1>
      <Icon
        colorName={COLORS.zulu.$08}
        name="closeCross"
        onClick={() => handleCancel(onCancel)}
        size={2.5}
        testId={partTestId(testId, 'close')}
      />
    </header>
  );
};

const Content = ({ children }: { children: ReactNode }) => <div className="modal-content">{children}</div>;

const Buttons = ({ children }: { children: ReactNode }) => <div className="modal-buttons">{children}</div>;

const ModalComponent = ({ children, className = '', onCancel, preventBackdropDismiss = false, testId }: ModalProps) => {
  return (
    <div data-test={testId}>
      <button
        className="modal-dimmer"
        onClick={preventBackdropDismiss ? undefined : () => handleCancel(onCancel)}
        type="button"
      />
      <div className={classnames('modal', className)}>
        <div className="modal-box">{children}</div>
      </div>
    </div>
  );
};

const Modal = Object.assign(ModalComponent, { Buttons, Content, Header });
export { Modal };
